module.exports = __webpack_public_path__ + "static/media/hifi.b0102a7c.jpg";